import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "./assets/css/element-variables.scss"
import './assets/css/global.scss'
import i18n from './locale' // 导入配置
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
Vue.config.productionTip = false

Vue.use(ElementUI)

let clientWidth = document.body.clientWidth || document.documentElement.clientWidth
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '发发'
  next()
  // if(to.path === "/" && clientWidth < 500){
  //   next("/download");
  // }else{
  //   next();
  // }
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
